import { Component } from '@angular/core';
import { AuthorizationMatrix } from 'app/core/store/session/authorization/authorization.interface';
import { fadeInAnimation } from '../../../../animations';
import { EpsUsersLoadAction } from '../../../../core/store/admin/users/users.actions';
import { EpsUser, EpsUsers } from '../../../../core/store/admin/users/users.interface';
import { UserPageContainer } from '../../abstract-user/user-page-container/user-page.container';
import { goAction } from '../../../../core/store/router/router.actions';
import { map, takeWhile } from 'rxjs/operators';
import { UsersSandbox } from '../../../../core/sandboxes/users.sandbox';

@Component({
  selector: 'admin-eps-user-page',
  templateUrl: './eps-user-page.container.html',
  styleUrls: ['../../abstract-user/user-page-container/user-page.container.scss'],
  animations: [fadeInAnimation],
})
export class EpsUserPageContainer extends UserPageContainer {
  users: EpsUsers;
  sortField: string;
  sortAscending: boolean;
  authorization: AuthorizationMatrix;

  constructor(public usersSandbox: UsersSandbox) {
    super();
    this.store
      .select('admin')
      .pipe(
        takeWhile(() => !this.destroyed),
        map((admin: { epsUsers: EpsUsers }) => admin && admin.epsUsers)
      )
      .subscribe(users => {
        this.users = users;
        this.pageNr = users.pageNr;
        this.sortField = users.sortField;
        this.sortAscending = users.sortAscending;
      });
  }

  protected reload(): void {
    this.store.dispatch(
      new EpsUsersLoadAction({
        adminDefinitions: this.adminDefinitions,
        filter: this.filter,
        pageSize: this.pageSize,
        pageNr: this.pageNr,
        sortField: this.sortField,
        sortAscending: this.sortAscending,
      })
    );
  }

  openEpsUser(epsUser: EpsUser): void {
    if (this.userContext.adminRoles.updateEpsUser) {
      this.store.dispatch(goAction({ path: `/admin/epsUsers/${epsUser.id}/edit` }));
    } else {
      this.store.dispatch(goAction({ path: `/admin/epsUsers/${epsUser.id}` }));
    }
  }

  onPageChange(pageNr): void {
    this.pageNr = pageNr;
    this.reload();
  }

  sortChange({ sortField, sortAscending }) {
    this.sortField = sortField;
    this.sortAscending = sortAscending;
    this.reload();
  }

  inviteNewEpsUser() {
    this.store.dispatch(goAction({ path: '/admin/epsUsers/invite' }));
  }

  downloadList() {
    this.usersSandbox.downloadEpsUsers(this.filter);
  }
}
